import React, { ReactNode, memo, useState } from 'react';
import { Form } from 'react-bootstrap';

import Button from 'src/components/common/button/button';
import { SearchModal } from 'src/components/main/quiz/hometown-step/components/search-modal/';
import StepHeader from 'src/components/main/quiz/step-header/step-header';

import styles from './hometown-step.module.scss';

const HometownStep = ({
  value,
  title,
  subtitle,
  onChange,
  goToNextStep,
}: {
  title: ReactNode;
  subtitle: ReactNode;
  value?: string;
  onChange: (value: string, latitude: number, longitude: number) => void;
  goToNextStep: () => void;
}) => {
  const [showSearchingModal, setSearchingModal] = useState(false);

  const handleSelect = (value: string, latitude: number, longitude: number) => {
    setSearchingModal(false);
    onChange(value, latitude, longitude);
  };

  return (
    <div className={styles.form}>
      <StepHeader title={title} subtitle={subtitle} />
      <Form.Control
        className={styles.input}
        readOnly
        value={value}
        placeholder="Enter your city"
        onClick={() => setSearchingModal(true)}
      />

      <SearchModal show={showSearchingModal} handleSelect={handleSelect} />

      <Button
        className={styles.submitButton}
        disabled={!value}
        onClick={() => goToNextStep()}>
        Next
      </Button>
    </div>
  );
};

export default memo(HometownStep);
